import React, { useState, useEffect }from 'react';

import PropTypes from 'prop-types';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import '../../styles/style.scss';
import '../../styles/createRolStyle.scss';

import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  Typography,
  FormControl,
} from '@material-ui/core';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import Swal from 'sweetalert2';
import { actionErrorConnection } from '../../constants/component/actionErrorConnection';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import {CustomCheckbox} from '../../constants/customComponent/CustomCheckbox'
import userAdminZoneService from '../../services/userAdminZone.service';
import { useAuthInfo } from '../../utils/authUtils';

export const ConfigUserAdminZoneScreen = () => {

  const {noCustomer} = useAuthInfo()

  const dispatch = useDispatch();
  const history = useHistory();

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const initialState = {
    name: '',
    customers:[]
  }

  const [isloadingData, setIsLoadingData] = useState(false);
  const [customersList, setCustomersList] = useState([]);
  const [customersAssociatesList, setCustomersAssociatesList] = useState([]);
  const [zones, setZones] = useState([]);
  const [checkedCustomers, setCheckedCustomers] = useState(initialState.customers);
  const [isDisabled, setDisabled] = useState(false);

  const validationSchema = Yup.object().shape({
    customers: Yup.array().required('Sucursal requerida')
    .test('','Seleccionar por lo menos una sucursal',()=> checkedCustomers.length > 0)
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    //watch,
    //register,
    setValue
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      'customers': checkedCustomers
    }
  });


  useEffect(() => {
    getUsers();
    getClientAssociates(noCustomer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  }

  /**
   * Recupera lista de clientes registrados
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024
   *
  */
  const getUsers = () => {
    setIsLoadingData(true)
    userAdminZoneService.getRegisterCustomers().then(
      (response) => {
        setIsLoadingData(false)

        const sortedList = response.sort((a,b) => a.zona - b.zona);

        const zonesList = sortedList.map((z) => z.zona?.trim());
        const zonesListFiltered = zonesList.filter(onlyUnique);

        setZones(zonesListFiltered);
        setCustomersList(sortedList);
      }).catch((error)=>{
        setIsLoadingData(false)
        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
      } else{
          actionErrorConnection(error, 'Error al recuperar sucursales.');
      }
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al recuperar lista de sucursales. Intente más tarde.',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
      });
    })
  }

    /**
   * Recupera lista de clientes asociados al usuario
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024
   *
  */
    const getClientAssociates = (an8AdminZone) => {
      setIsLoadingData(true)
      userAdminZoneService.getAdminZoneClientListByAN8(an8AdminZone).then(
        (response) => {
          let initCheckedCustomers = [];
          setIsLoadingData(false)
          setCustomersAssociatesList(response);
          response.forEach(({an8})=>{
            initCheckedCustomers.push(an8)
          });
          setCheckedCustomers(initCheckedCustomers);
          setValue('customers', initCheckedCustomers);
        }).catch((error)=>{
          setIsLoadingData(false)
          if(sessionDifference > Number(tokenExpired)){
            sesionExpired(dispatch, history);
        } else{
            actionErrorConnection(error, 'Error al recuperar clientes asociados al administrador de zona.');
        }
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al recuperar clientes asociados al administrador de zona.. Intente más tarde.',
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
        });
      })
    }

  /**
   * Cambia lista de usuarios seleccionedos
   * @param {*} checkedId - identificador del checkbox que cambiara lista de usuarios
   * @returns { array } arreglo con los checkbox activos
   * @author alSanchez - ETE
    * @version 1.0.0 - Febrero 2024
   */
  const handleSelectCustomers = (checkedId) => {
    const newIds = checkedCustomers?.includes(checkedId)
      ? checkedCustomers?.filter(name => name !== checkedId)
      : [...(checkedCustomers ?? []), checkedId];
    setCheckedCustomers(newIds);
    return newIds;
  }

  /**
   * Envia el formulario para asignar clientes al administrador de zona
   * @param {*} data - informacion del formulario
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024
   */
  const onSubmit = () => {
    setDisabled(true);

    let dataToSend = checkedCustomers;

    if(customersAssociatesList.length > 0){
      updateConfig(dataToSend, noCustomer);
    }else{
      createConfig(dataToSend, noCustomer);
    }
  };

  /**
   * solicita la creación de asociación de clientes
   * @param {*} userData - informacion del formulario
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024
   */
  const createConfig = (userData, customer) =>{
    userAdminZoneService.createAdminZone(userData, customer).then(()=>{
      setDisabled(false);
      Swal.fire({
        icon: 'success',
        title: 'Asignación de sucursales exitosa',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar'
      })
    }).catch((error)=>{
      setDisabled(false);
      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al asignar sucursales');
        }
    });
  }

  /**
 * Solicita la actualización de asociación de clientes
 * @param {*} userData - informacion del formulario
 * * @param {number} customer - identificador del rol
 * @author alSanchez - ETE
 * @version 1.0.0 - Febrero 2024
 */
  const updateConfig = (userData, customer) =>{
    userAdminZoneService.updateAdminZone(userData, customer).then(()=>{
      setDisabled(false);
      Swal.fire({
        icon: 'success',
        title: 'Asignación de sucursales exitosa',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar'
      })
    }).catch((error)=>{
      setDisabled(false);
      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al asignar sucursales');
        }
    });
  }
  const generateNewZones = (z) => (
    <>
    <div key={`checkboxgrouptitle-${z}-${Math.random()}`} className='checkbox-group-title'>
      <h4 key={`zona-${z}-${Math.random()}`}>Zona: {z}</h4>
      <Controller
        id={'selectall'+z}
        name={'selectall'+z}
        render={({field:{onChange}}) =>
          <SelectAllCheckBox onChange={onChange} handleClickSelectAll={handleClickSelectAll} z={z
          }/>
        }
        control={control}
      />
    </div>

    <Controller
      id="customers"
      name="customers"
      render={({field:{onChange}}) =>
          handleCreateCheckBox(onChange,z)
      }
      control={control}
    />
  </>
  )
  /**
   * Construye la lista de zonas, junto con las sucursales de esas zonas.
   * @returns arreglo de zonas y sucursales.
   * @author clopez -ETE
   * @version 1.0.0 - Junio 2024
   */
  const createCheckboxList = () => {
    let newZones = [];

    zones.forEach((z, index) => {
      newZones.push(
        generateNewZones(z, index)
      )
    });
    return newZones;
  }
  const handleCreateCheckBox = (onChange,z) =>{
    const customerListFiltered = customersList.filter(c => c.zona.trim() === z);
    return createCheckboxGroup(customerListFiltered, onChange);
  }
  /**
   * Construye la lista de checbox de sucursales.
   * @param {*} branches array de sucursales.
   * @param {*} onChange función de onChange para asignársela al checkbox.
   * @returns lista de controles de checkbox de sucursales.
   * @author clopez - ETE
   * @version 1.0.0 - Junio 2024
   */
  const createCheckboxGroup = (branches, onChange) => {
    let grouped = [];
    branches.forEach((c) => {
      grouped.push(
        <div className="col-md-6" key={`grouped-${c.an8}-${Math.random()}`}>
          <FormControlLabel
            control={
              <CustomCheckbox
                onChange={() => onChange(handleSelectCustomers(c.an8))}
                checked={checkedCustomers?.includes(c.an8)}
                />
            }
            label={
              <span className="checkbox-text"><strong>{c.an8}</strong> - {c.name}</span>
            }
          />
        </div>
      )
    });
    return grouped;
  }

  /**
   * Evento que se dispara con el checkbox Seleccionar/Deseleccionar
   * @param {*} zona zona seleccionada
   * @author clopez - ETE
   * @version 1.0.0 - Junio 2024
   */
  const handleClickSelectAll = (zona) => {
    const filtered = customersList.filter(f => f.zona?.trim() === zona);
    const an8List = filtered.map((z) => z.an8);

    let an8NewList = checkedCustomers;
    an8List.forEach((an8) => {
      an8NewList = an8NewList?.includes(an8)
      ? an8NewList?.filter(name => name !== an8)
      : [...(an8NewList ?? []), an8];
      });
    setValue('customers', an8NewList);
    setCheckedCustomers(an8NewList);
  }

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
              <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
              </div>
              <div className="col p-0 ms-1 me-1">
                <NavTopMenu />

                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div>
                      <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                        <span>Administrador de zona </span>
                      </div>
                      <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                        <form>
                          <div className="container p-0">
                            {isloadingData && <div><i className="fas fa-spinner fa-spin ms-2"></i></div>}
                            <div className='row'>
                              <div className="col-md-3">
                                <div className="border-text-menu-title">
                                  <span className="text-subtitle">Asignar Sucursales</span>
                                </div>
                              </div>
                              <div className="col-md-9  pt-5">
                                <FormControl  className="w-100 container-checkbox-size" error={!!errors.customers?.message}>
                                  <div className="row w-100 ">
                                    {createCheckboxList()}
                                  </div>
                                </FormControl>
                                <Typography variant="inherit" color="error">
                                    {errors.customers?.message}
                                </Typography>
                              </div>
                            </div>
                            <div className="d-flex flex-row-reverse ">
                              <div className="col-md-9 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                                <button
                                className="btn custom-btn pt-2 pb-2 ps-3 pe-3"
                                onClick={handleSubmit(onSubmit)}
                                disabled={ isDisabled }>
                                        {customersAssociatesList.length > 0 ? 'Actualizar' : 'Asociar'} { isDisabled && <i className="fas fa-spinner fa-spin"></i>}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer/>
        </>
    )
}

ConfigUserAdminZoneScreen.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  history: PropTypes.object
}

const SelectAllCheckBox = ({onChange, handleClickSelectAll,z}) => {
  return(
    <FormControlLabel
    control={
      <CustomCheckbox
        onChange={() => onChange(handleClickSelectAll(z))}
        checked={false}
      />
    }
    label={'Seleccionar/Deseleccionar'}
  />
  )
}

SelectAllCheckBox.propTypes = {
  onChange: PropTypes.func,
  handleClickSelectAll: PropTypes.func,
  z: PropTypes.string
}